<button *ngIf="showPlayButton" class="btn-audio" (click)="play()"
    [style.background-color]="disabled ? 'grey' : ''"
><fa-icon [icon]="faPlay"></fa-icon></button>
<button *ngIf="!showPlayButton" class="btn-audio" (click)="pause()"><fa-icon [icon]="faPause"></fa-icon></button>